import type { ArdoqId } from '@ardoq/api-types';
import {
  nodesComponentIds,
  type DependencyMapNode,
} from '@ardoq/dependency-map';
import { uniq } from 'lodash';

export const getDependencyMapViewComponentIds = (
  rawNodes: DependencyMapNode[]
): ArdoqId[] => uniq([...nodesComponentIds(rawNodes)]);
